import { toast } from 'react-toastify';

export const notifyError = (message, closeAction = null) => {
	// Remove all toasts !
	toast.dismiss();

	toast.error(message, {
		position: toast.POSITION.TOP_CENTER,
		toastId: 'nfyRegisterApiError' + new Date().getTime(),
		onClose: closeAction,
		className: 'black-background'
	});
};

export const notifyInfo = (message, closeAction = null) => {
	// Remove all toasts !
	toast.dismiss();

	toast.info(message, {
		position: toast.POSITION.TOP_CENTER,
		toastId: 'nfyRegisterMsg' + new Date().getTime(),
		onClose: closeAction,
		className: 'black-background'
	});
};

export const clearNotifications = () => {
	toast.dismiss();
};
